import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { Props } from "../../types/global";
import ContactBlock from "./ContactBlock";
import { Footer } from "./Footer";
import t from "../i18n";
import { Loading } from "../common/Loading";

declare type ContactListState = {
    phoneBooks?: any[];
}
export class ContactList extends React.Component<Props, ContactListState> {
    readonly state: ContactListState = { };
    componentDidMount() {
        MyAccountService.fetchPhoneBook().then(result =>
            this.setState({ phoneBooks: result.payLoad || [] })
        );
    }
    topupByContact = (entry: any) => {
        this.props.history.push(`/topup?cc=${entry.countryCode}&m=${entry.mobileNumber}&p=${entry.productId}`);
    }
    newContact = () => {
        this.props.history.replace("/contact/new");
    }
    render() {
        if (!this.state.phoneBooks) return <Loading />;
        return <div className="container-fluid" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{t.menu("contact_list")}</h2>
            </div>
            <div className="row">
                {this.state.phoneBooks.map(book => <ContactBlock key={book.phonebookId}
                    entry={book} onTopupByContact={this.topupByContact} />)}
            </div>
            <Footer onButtonClick={this.newContact} buttonText={t.myaccount("new_contact")} />
        </div>
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}